<template>
  <v-container
    class="pa-0"
    grid-list-xl
    fluid
  >
    <v-layout wrap>
      <!-- Left column contains Start/End date filters in v-flex -->
      <v-flex
        sm6
        xs12
        md4
        lg4>
        <v-menu
          ref="menu1"
          :close-on-content-click="false"
          v-model="menu1"
          :nudge-right="40"
          :return-value.sync="dateFrom"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="computedDateFromFormatted"
            label="Start Date"

            prepend-icon="mdi-calendar"
            readonly
          />
          <v-date-picker
            v-model="dateFrom"
            no-title
            @input="$refs.menu1.save(dateFrom)"
            min="2020-01-01"/>
        </v-menu>

        <v-menu
          ref="menu2"
          :close-on-content-click="false"
          v-model="menu2"
          :nudge-right="40"
          :return-value.sync="dateTo"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="computedDateToFormatted"
            label="End Date"

            prepend-icon="mdi-calendar"
            readonly
          />
          <v-date-picker
            v-model="dateTo"
            no-title
            @input="$refs.menu2.save(dateTo)"
            min="2020-01-01"/>
        </v-menu>

      </v-flex>

      <!-- Middle column contains state, retailer, distributor, brand filters -->
      <v-flex
        v-if="loginType == 'client'"
        sm6
        xs12
        md4
        lg4>
        <v-select
          :items="this.$store.state.stateList"
          v-model="stateFilter"
          label="State" />
        <v-select
          :items="this.$store.state.storeTypes"
          v-model="storeFilter"
          label="Retailer" />
        <v-select
          v-if="loginType == 'client' && agencyView == '1'"
          :items="this.$store.state.agenciesList" 
          v-model="agencyFilter"
          label="Agency"
          item-text="name" 
          item-value="name" 
          @change="getRecaps"
        />
        <v-select
          v-if="loginType == 'client' && distributorView == '1'"
          :items="this.$store.state.distributorsList"
          v-model="distributorFilter"
          label="Distributor"
          item-text="name"
          item-value="name"
          @change="getRecaps"
        />
        <v-select
          :items="this.$store.state.brandsList"
          v-model="brandFilter"
          label="Brand"
          item-text="name"
          item-value="name"
        />
      </v-flex>
      <v-flex
        sm8
        xs12
        md3
        lg2>
        <v-btn
          :loading="csvExporting"
          :disabled="csvExporting"
          flat
          large
          @click.native="exportCSV"
        >
          <v-icon large color="dark_grey">mdi-cloud-download</v-icon> &nbsp;.csv
        </v-btn>
      </v-flex>

      <v-flex
        md12
        lg12
      >
        <material-card
          color="secondary"
        >
          <template slot="header">
            <div>
              <h4
                class="title font-weight-light mb-2"
                style="float:left">
                Event Details
              </h4><v-spacer/><v-btn
                style="float:right"
                @click="expandRecaps"
                color="darker_grey">Expand All</v-btn>
              <p
                class="category font-weight-thin"
                style="float:left;clear:left"
              >Events Executed this Period
              </p>
              <br style="clear:both">
            </div>

          </template>
          <v-data-table
            ref="recapTable"
            :headers="headers"
            :items="this.$store.state.recaps"
            class="elevation-1"
            item-key="recap_id"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn
                    small
                    flat
                    icon>
                    <v-icon
                      v-if="props.expanded"
                      small>mdi-chevron-down</v-icon>
                    <v-icon
                      v-else
                      small>mdi-chevron-right</v-icon>
                  </v-btn>
                  {{ formatDate(props.item.timesheet_date) }}</td>
                <td>{{ props.item.warehouse_id }}</td>
                <td>{{ props.item.storename }}</td>
                <td>{{ props.item.agency_name }}</td>
                <td>{{ props.item.state }}</td>
                <td class="text-xs-right">{{ props.item.bottles_sold.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
                <td><a
                  :href="props.item.pdf"
                  @click.stop >
                  <v-icon
                    size="20"
                    class="mr-2">
                    mdi-cloud-download
                </v-icon></a>&nbsp;

                </td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props">
              <event-details :recap="props.item" :show-supplier="$store.state.login_type === 'retail'" />
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <div v-if="loading && isRecapsEmpty" class="recaps-throbber">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>
    <div v-else-if="loading" class="recaps-spinner-top">
      <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import EventDetails from '../components/EventDetails'
import { TokenService } from '../services/storage.service'
var d = new Date()

const month = '' + (d.getMonth() + 1)
const day = '' + d.getDate()
var default_date_end = '' + d.getFullYear() + `-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
var default_date_from = '' + d.getFullYear() + `-${month.padStart(2, '0')}-01`

export default {
  components: { EventDetails },
  data: () => ({
    csvExporting: false,
    dateFromFormatted: '01/01/2019',
    dateToFormatted: '03/03/2019',
    menu2: false,
    menu1: false,
    rowsPerPageItems: [10, 30, 50, 100],
      pagination: {
        rowsPerPage: 30,
        sortBy: 'timesheet_date',
        descending: true
      }, 
    menu4: false,
    loading: false,
    headers: [
      {
        sortable: true,
        text: 'Date',
        value: 'timesheet_date'
      },
      {
        sortable: true,
        text: 'Store',
        value: 'warehouse_id'
      },
      {
        sortable: true,
        text: 'Location',
        value: 'storename'
      },
      {
        sortable: true,
        text: 'Agency',
        value: 'agency_name'
      },
      {
        sortable: true,
        text: 'State',
        value: 'state'
      },
      {
        sortable: true,
        text: 'Total Units Sold',
        value: 'bottles_sold',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Details',
        value: 'pdf'
      }
    ]

  }),

  computed: {
    computedDateFromFormatted () {
      return this.formatDate(this.dateFrom)
    },

    loginType () {
      return this.$store.state.login_type
    },

    agencyView () {
      return this.$store.state.agencyView
    },

    distributorView () {
      return this.$store.state.distributorView
    },

    computedDateToFormatted () {
      return this.formatDate(this.dateTo)
    },

    apihost () {
      return this.$store.state.apiRoot
    },

    stateFilter: {
      get () {
        return this.$store.state.stateFilter
      },
      set (value) {
        this.$store.commit('setStateFilter', value)
      }
    },

    agencyFilter: {
      get () {
        return this.$store.state.agencyFilter
      },
      set (value) {
        this.$store.commit('setAgencyFilter', value)
      }
    },

    distributorFilter: {
      get () {
        return this.$store.state.distributorFilter
      },
      set (value) {
        this.$store.commit('setDistributorFilter', value)
      }
    },

    brandFilter: {
      get () {
        return this.$store.state.brandFilter
      },
      set (value) {
        this.$store.commit('setBrandFilter', value)
      }
    },

    storeFilter: {
      get () {
        return this.$store.state.storeFilter
      },
      set (value) {
        this.$store.commit('setStoreFilter', value)
      }
    },
    dateFrom: {
      get () {
        return this.$store.state.dateFrom
      },
      set (value) {
        this.$store.commit('setDateFrom', value)
      }
    },

    dateTo: {
      get () {
        return this.$store.state.dateTo
      },
      set (value) {
        this.$store.commit('setDateTo', value)
      }
    },

    // This checks if recaps contains only the initialized empty data so we can show the spinner
    isRecapsEmpty () { 
      return !this.$store.state.recaps ||
        (this.$store.state.recaps.length === 1 && this.$store.state.recaps[0].recap_id === 0)
    }

  },

  watch: {

    dateFrom (val) {
      this.dateFromFormatted = this.formatDate(this.dateFrom)
      if (this.dateTo != null) {
        this.getRecaps()
        this.$store.dispatch('get_states', { dateStart: this.dateFrom, dateEnd: this.dateTo })
      } 
    },

    dateTo (val) {
      this.dateToFormatted = this.formatDate(this.dateTo)
      if (this.dateFrom != null) {
        this.getRecaps()
        this.$store.dispatch('get_states', { dateStart: this.dateFrom, dateEnd: this.dateTo })
      }
    },

    stateFilter (val) {
      this.getRecaps()
    },

    storeFilter (val) {
      this.getRecaps()
    },

    agencyFilter (val) {
      this.getRecaps()
    },

    distributorFilter (val) {
      this.getRecaps()
    }

    ,

    brandFilter (val) {
      this.getRecaps()
    }

  },

  created () {
    this.$store.commit('setAgencyView', TokenService.getAgencyView())
    this.getRecaps()
  },

  methods: {

    exportCSV () {
      this.csvExporting = true
      var context = this
      console.log('start download file')

      const params = new URLSearchParams({
        access_key: TokenService.getAccessKey(),
        filetype: 'csv',
        date_start: this.$store.state.dateFrom,
        date_end: this.$store.state.dateTo
      })

      if (this.$store.state.stateFilter && this.$store.state.stateFilter !== 'All') {
        params.append('state', this.$store.state.stateFilter)
      }

      if (this.$store.state.storeFilter && this.$store.state.storeFilter !== 'All') {
        params.append('store_type', this.$store.state.storeFilter)
      }

      if (this.$store.state.agencyFilter && this.$store.state.agencyFilter !== 'All') {
        params.append('agency', this.$store.state.agencyFilter)
      }

      if (this.$store.state.distributorFilter && this.$store.state.distributorFilter !== 'All') {
        params.append('distributor', this.$store.state.distributorFilter)
      }

      if (this.$store.state.brandFilter && this.$store.state.brandFilter !== 'All') {
        params.append('brand', this.$store.state.brandFilter)
      }

      var login_type = ""
        if (this.$store.state.login_type == 'client') {
           login_type = "clients/"
        } else {
          login_type = "retail/"
        }

      var url = this.$store.state.apiRoot + login_type + TokenService.getLoginCode() + '/recaps?' + params.toString()
      window.location.href = url

      setTimeout(function () {
        console.log('finish download file')
        context.csvExporting = false
      }, 3500)
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatTime (time) {
      var [hour, minute, second] = time.split(':')
      var meridian = ' AM'
      if (hour >= 12) {
        meridian = ' PM'
      }
      if (hour > 12) {
        hour = hour - 12
      }
      return '' + hour + ':' + minute + meridian
    },

    async getRecaps () {
      this.loading = true
      try {
        await this.$store.dispatch('get_storeTypes', { dateStart: this.dateFrom, dateEnd: this.dateTo })
        await this.$store.dispatch('get_agencies')
        if (!this.$store.state.distributorsList || this.$store.state.distributorsList.length === 0) {
          await this.$store.dispatch('get_distributors')
        }
        if (!this.$store.state.brandsList || this.$store.state.brandsList.length === 0) {
          await this.$store.dispatch('get_brands')
        }
        await this.$store.dispatch('get_recaps', {
          dateStart: this.dateFrom,
          dateEnd: this.dateTo,
          state: this.stateFilter,
          storeType: this.storeFilter,
          agency: this.agencyFilter,
          distributor: this.distributorFilter,
          brand: this.brandFilter
        })
      } catch (e) {
        console.error("Something happened while we were waiting for promises to resolve:", e)
      }
      this.loading = false
    },

    expandRecaps: function () {
      for (let i = 0; i < this.$store.state.recaps.length; i += 1) {
        const item = this.$store.state.recaps[i]
        this.$set(this.$refs.recapTable.expanded, item.recap_id, true)
      }
    },

    complete (index) {
      this.list[index] = !this.list[index]
    }
  }
}
</script>

<style lang="scss">
  .tim-note {
    bottom: 10px;
    color: #c0c1c2;
    display: block;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    left: 0;
    margin-left: 20px;
    width: 260px;
  }

  .recaps-throbber {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255,255,255,0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .recaps-spinner-top {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    background: none;
  }
</style>
